<template>
  <div class="engine-data-chart">
    <div class="engine-data-chart-parent-container">
      <draggable
        :value="sortedChannelIds"
        :disabled="!(selectedChannelOriginId === 'custom')"
        @start="drag = true"
        @end="handleDragEndChannelRow"
        v-bind="dragOptions"
        :options="{handle: '.column-handle-btn'}"
      >
        <transition-group
          type="transition"
          :name="!drag ? 'flip-list' : null"
          style="display: contents"
        >
          <div
            class="row channel-row flex"
            v-for="data in sortedChannelData"
            :key="data.channel_id"
            v-show="
              (!data.hasError && showNormalValue) ||
              (data.hasError && showAbnormalValue)
            "
            :style="{ height: deviceType !== 'iPhone' ? '80px' : '60px' }"
          >
            <div
              class="
                column-handle-btn
                aisea-text-16-400-black
                pl-6
                flex-shrink-0
                cursor-pointer
              "
              :class="{
                'error-text': getSafelyDisplayMap(data.channel_id).error,
              }"
              v-show="selectedChannelOriginId === 'custom'"
            >
              <span class="material-icons" style="font-size: 14px">
                drag_handle
              </span>
            </div>
            <div
              class="
                column-channel-id
                aisea-text-16-400-black
                pl-6
                flex-shrink-0
                relative
              "
              :class="{
                'error-text': getSafelyDisplayMap(data.channel_id).error,
              }"
            >
              <vs-dropdown
                class="more-button w-full cursor-pointer stretched-link"
                color="#2D9CDB"
                vs-trigger-click
                @click="handleClickMoreBtn"
              >
                <div class="truncate text-left aisea-text-16-400-black">{{ data.channel_id }}</div>
                <vs-dropdown-menu
                  class="
                    column-channel-name-more-button-dropdown
                    column-channel-name-dropdown
                  "
                  v-show="!drag"
                >
                  <vs-dropdown-item
                    @click="
                      selectedChannelOriginId !== 'custom'
                        ? handleClickAddCustomReportBtn(data)
                        : removeCustomChannelId(data)
                    "
                    class="add-custom-report-btn m-0"
                  >
                    <span class="flex justify-between items-center">
                      <span class="material-icons-outlined">
                        {{
                          selectedChannelOriginId !== "custom"
                            ? "add"
                            : "delete"
                        }}
                      </span>
                      <span>{{
                        selectedChannelOriginId !== "custom"
                          ? "カスタムレポートに追加"
                          : "カスタムレポートから削除"
                      }}</span>
                    </span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
            <div
              class="
                column-channel-name
                pl-3
                aisea-text-16-400-black
                flex-shrink-0
                flex-grow
                relative
              "
              :class="{
                'error-text': getSafelyDisplayMap(data.channel_id).error,
              }"
            >
              <vs-dropdown
                class="more-button w-full cursor-pointer stretched-link"
                color="#2D9CDB"
                vs-trigger-click
                @click="handleClickMoreBtn"
              >
                <div class="truncate text-left aisea-text-16-400-black">
                  <div class="channel-id">{{ data.channel_id }}</div>
                  {{ data.channel_name }}
                </div>
                <vs-dropdown-menu
                  class="
                    column-channel-name-more-button-dropdown
                    column-channel-name-dropdown
                  "
                  v-show="!drag"
                >
                  <vs-dropdown-item
                    @click="
                      selectedChannelOriginId !== 'custom'
                        ? handleClickAddCustomReportBtn(data)
                        : removeCustomChannelId(data)
                    "
                    class="add-custom-report-btn m-0"
                  >
                    <span class="flex justify-between items-center">
                      <span class="material-icons-outlined">
                        {{
                          selectedChannelOriginId !== "custom"
                            ? "add"
                            : "delete"
                        }}
                      </span>
                      <span>{{
                        selectedChannelOriginId !== "custom"
                          ? "カスタムレポートに追加"
                          : "カスタムレポートから削除"
                      }}</span>
                    </span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
            <div
              class="
                flex
                justify-end
                column-value
                aisea-text-20-400-blue
                items-baseline
                flex-shrink-0
                ml-auto
              "
              :class="{
                'error-text': getSafelyDisplayMap(data.channel_id).error,
              }"
            >
              <span class="value truncate">{{
                getYValueDisp(getSafelyDisplayMap(data.channel_id).value)
              }}</span>
              <span
                class="unit aisea-text-10-400-blue ml-2"
                :class="{
                  'error-text': getSafelyDisplayMap(data.channel_id).error,
                }"
                >{{
                  getSafelyDisplayMap(data.channel_id).value ||
                  getSafelyDisplayMap(data.channel_id).value === 0
                    ? data.display_unit
                    : "-"
                }}</span
              >
            </div>
            <div
              class="
                flex
                justify-start
                items-center
                column-channel-chart column-chart
                flex-shrink-0
                relative
                mr-6
                pl-6
              "
              :class="{
                'error-chart': getSafelyDisplayMap(data.channel_id).error,
              }"
            >
              <div
                :id="'container-parent-' + data.channel_id_escaped"
                class="vs-con-loading__container no-spacer cursor-pointer chart-container-wrapper"
                style="height: 100%; padding: 4px 0; z-index: 3; width: 100%;"
                :style="{ display: deviceType !== 'iPhone' ? 'block' : 'none' }"
                @click="handleClickExpandBtn(data)"
              >
                <div
                  :id="'container-' + data.channel_id_escaped"
                  class="chart-container no-spacer"
                ></div>
                <div class="chart-control-area">
                  <div
                    class="chart-expand-btn absolute hidden"
                    :style="{ bottom: '4px', right: '4px' }"
                  >
                    <span
                      class="trim-image cursor-pointer"
                      :style="{
                        display: deviceType !== 'iPhone' ? 'block' : 'none',
                        background: 'rgba(45, 156, 219, 0.5)',
                        'border-radius': '6px',
                        color: '#F8F8F8',
                        height: '24px',
                        width: '24px',
                        display: 'flex',
                        'align-items': 'center',
                        'justify-content': 'center',
                      }"
                    >
                      <span
                        class="material-icons"
                        :style="{ 'font-size': '18px' }"
                      >
                        zoom_in
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition-group>
      </draggable>
    </div>

    <transition name="fade">
      <engine-data-expanded-chart
        :popupActive="popupActive"
        @closePopup="popupActive = false"
        :expandedChartData="expandedChartData"
        :channelDataRecord="channelDataRecord"
        :channelTimeFrom="getChannelTimeFrom"
        :channelTimeTo="getChannelTimeTo"
        :selectedChannelOriginId="selectedChannelOriginId"
        :handleClickAddCustomReportBtn="handleClickAddCustomReportBtn"
        :removeCustomChannelId="removeCustomChannelId"
        @expandPrevChart="handleEmitExpandPrevChart"
        @expandNextChart="handleEmitExpandNextChart"
        :xAxisStartValue="xAxisStartValue"
        :xAxisEndValue="xAxisEndValue"
      />
    </transition>
  </div>
</template>

<script src="https://code.highcharts.com/modules/series-label.js"></script>

<script>
import Vue from 'vue'
import _ from "lodash";
import { db } from "@/firebase/firebaseConfig.js";
import Highcharts from 'highcharts';
import moment from "moment";
import {createNamespacedHelpers} from "vuex";
const { mapGetters, mapActions, mapState } = createNamespacedHelpers("enterpriseVesselMonitoringEngine");
import WebWorkerForSaveChannelData from 'worker-loader!@/utils/worker/WebWorkerForSaveChannelData.js';
import { ColorMixin } from "@/mixins";
import draggable from "vuedraggable";
import EngineDataExpandedChart from "./EngineDataExpandedChart.vue";

export default {
  name: "engineDataChart",
  components: {
    draggable,
    EngineDataExpandedChart,
  },
  props: [
    'channel_data',
    'xAxisValue',
    'showNormalValue',
    'showAbnormalValue',
    'deviceType',
  ],
  mixins: [ColorMixin],
  computed: {
    ...mapGetters(["getChannelTimeFrom", "getChannelTimeTo", "getCustomChannelIds", "getChannelOriginList", ]),
    ...mapState({
      mode: state => state.mode,
      // liveDataTimeRange: state => state.liveDataTimeRange,
      kind: state => state.kind,
      referencedChannelIdMap: state => state.referencedChannelIdMap,
      engineInfo: state => state.engineInfo,
      channelOriginsMap: state => state.channelOriginsMap,
      selectedChannelOriginId: state => state.selectedChannelOriginId,
    }),
    dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: "ghost",
      };
    },
    xAxisValueSync: {
      get() {
        return this.xAxisValue;
      },
      set(val) {
        this.$emit('update:xAxisValue', val);
      }
    },
    checkedChannels() {
      return {
        engine: this.engineCheckedChannels,
        handling: this.handlingCheckedChannels,
      }
    },
    sortedChannelData() {
      if (this.selectedChannelOriginId !== "custom") {
        return this.channel_data.slice();
      }
      const channelDataMap = this.channel_data.reduce(
        (prev, cur) => ({ ...prev, [cur.channel_id]: cur }),
        {},
      );
      return this.sortedChannelIds
        .map((channelId) => channelDataMap[channelId])
        .filter((cd) => cd);
    },
  },
  data() {
    return {
      xAxisStartValue: null,
      xAxisEndValue: null,
      chartsMap: {},
      displayMap: {},
      engineCheckedChannels: [],
      handlingCheckedChannels: [],
      unsubscribe: [],
      popupActive: false,
      removeTargetText: null,
      maxPointX: null,
      movingXAxis: false,
      isLoadingPlotDataMap: {},
      adjustBufferMinutes: 2,
      webWorker: null,
      setTimeoutList: [],
      zoomValueMap: {},
      drag: false,
      sortedChannelIds: [],  // チャンネルデータのソート状態を保持
      dataForExpanded: [],
      expandedChartData: [], // 詳細チャートで表示するデータ
      channelDataRecord: {},
    };
  },
  watch: {
    /**
     * 親コンポーネントからのチャンネルリストの変化に応じて再描画を行うトリガー.
     */
    channel_data() {
      if (!this.channel_data || this.channel_data.length === 0) {
        return;
      }
      this.setTimeoutList.forEach(timerId => clearTimeout(timerId));
      let newReferencedChannelIdMap = {} 
      this.channel_data.forEach(c => newReferencedChannelIdMap[c.channel_id] = c.channel_id);
      this.setReferencedChannelIdMap(Object.assign({}, this.referencedChannelIdMap, newReferencedChannelIdMap));
      this.sortedChannelIds = this.channel_data.map(cd => cd.channel_id);

      this.$nextTick(async () => {
        await this.redrawPointData();
        if ( this.mode === 'live' ) {
          await this.unsubscribeFirestoreForChart();
          this.subscribeFirestore();
        }
      });
    },
    maxPointX() {
      if ( this.maxPointX && this.movingXAxis === false  ) {
        this.movingXAxis = true;
        this.$nextTick(() => {

          const liveDataTimeRange = 60 * 24 * 3;
          const xAxisStartValue = moment.utc().valueOf() - ( liveDataTimeRange - this.adjustBufferMinutes ) * 60 * 1000;
          const xAxisEndValue = moment.utc(this.xAxisStartValue).valueOf() + liveDataTimeRange * 60 * 1000;

          let chartList = Object.values(this.chartsMap);
          chartList.forEach ( ( chart, index ) => {
            this.setTimeoutList.push(setTimeout(() => { 
              chart.xAxis[0].setExtremes(
                xAxisStartValue ,
                xAxisEndValue ,
              );
              if ( chartList.length -1 === index ) {
                this.maxPointX = null;
                this.movingXAxis = false;
              }
            }, Math.floor( index / 4 ) * 800));

            // chart.tooltip.hide();
            chart.series.forEach(series => {
              let point = series.data[series.data.length-1];
              chart.xAxis[0].drawCrosshair(event, point); 
              chart.tooltip.refresh(point);   // 重い処理。
            });

          });

          this.xAxisStartValue = xAxisStartValue;
          this.xAxisEndValue = xAxisEndValue;

        });
      }
    },
  },
  methods: {
    handleClickExpandBtn(channelData) {
      if (!channelData) return;
      if (!channelData.channel_id) return;
      this.expandedChartData =
        this.chartsMap[channelData.channel_id].series[0].options.data;
      this.channelDataRecord = channelData;
      this.popupActive = true;
    },
    handleEmitExpandPrevChart() {
      if (this.sortedChannelData.length <= 0) return;
      const currentIndex = this.sortedChannelData.findIndex(
        (cd) => cd.channel_id === this.channelDataRecord.channel_id,
      );
      if (currentIndex === -1) return;
      const toBeExpandedIndex =
        currentIndex === 0 ? this.sortedChannelData.length - 1 : currentIndex - 1;
      const toBeExpandedChannelData = this.sortedChannelData[toBeExpandedIndex];
      this.handleClickExpandBtn(toBeExpandedChannelData);
    },
    handleEmitExpandNextChart() {
      if (this.sortedChannelData.length <= 0) return;
      const currentIndex = this.sortedChannelData.findIndex(
        (cd) => cd.channel_id === this.channelDataRecord.channel_id,
      );
      if (currentIndex === -1) return;
      const toBeExpandedIndex =
        currentIndex === this.sortedChannelData.length - 1 ? 0 : currentIndex + 1;
      const toBeExpandedChannelData = this.sortedChannelData[toBeExpandedIndex];
      this.handleClickExpandBtn(toBeExpandedChannelData);
    },
    ...mapActions([
      "convertPointDataList", "convertChannelDataListForChart", "setReferencedChannelIdMap",
      "pushUnsubscribeForChart", "unsubscribeFirestoreForChart",
      "setCustomChannelIdsState",
    ]),

    async subscribeFirestore() {

      const liveDataTimeRange = 60 * 24 * 3;
      const engineInfo = this.engineInfo;
      const vesselId = engineInfo.vessel_info.id;

      let kindList = this.getChannelOriginList.map( x => x.kind );

      this.$nextTick(async () => {
        kindList.forEach(kind => {

          let versionName = engineInfo['version'][kind].version_name;

          const unsubscribe = db
            .collection("vessel_channel_data")
            .doc("v_" + vesselId)
            .collection(kind)
            .doc( versionName )
            .collection("data")
            // .where('timestamp', '>', latestTimestamp)  // where と orderbyを使うと遅くなった。
            .onSnapshot(snapshot => {snapshot.docChanges().forEach(diff => {if (diff.type !== 'removed') {

              const channelId = diff.doc.id;
              const docData = diff.doc.data();

              // チャートに座標を追加
              this.appendPointData(channelId, docData, liveDataTimeRange);

              // IndexedDBへの登録をWorkerに依頼
              if ( this.referencedChannelIdMap[channelId] ) {
                this.webWorker.postMessage({channelId: channelId, docData: docData, kind: kind, });
              }

            }});});
          this.pushUnsubscribeForChart(unsubscribe);

        });
      });
    },

    /**
     * ライブモードで新しい生データが投入された時に再描画を指示する.
     */
    async appendPointData(channelId, pointData, liveDataTimeRange) {

      const chart = this.chartsMap[channelId];
      if ( chart ) {
        if ( this.isLoadingPlotDataMap[channelId] ) {
          // ローディング中はアペンドしない。
          return;
        }
        const foundChannelData = this.channel_data.find(x => x.channel_id === channelId);
        if ( foundChannelData ) {

          const convertedPointDataList = await this.convertPointDataList({
            channel_id:           channelId,
            value_number_range:   foundChannelData.value_number_range,
            value_string_options: foundChannelData.value_string_options,
            pointDataList:        [ pointData ],
          });

          if ( convertedPointDataList.length > 0 ) {
            chart.series.forEach(series => {
              if ( series.data && series.data.length >= 0 ) {
                const nowMaxPointX = ( series.data.length === 0 ) ? 0 : series.data[series.data.length-1].x;
                if ( nowMaxPointX < convertedPointDataList[0].x ) { // 時間的に逆転するものは、描画対象から除外。

                  series.addPoint(convertedPointDataList[0]);

                  if ( ( chart.xAxis[0].getExtremes().max - convertedPointDataList[0].x ) < 20 * 1000) {
                    // 右端から20秒未満になったらフラグを立てる。
                    this.maxPointX = convertedPointDataList[0].x;
                  }

                  let point = series.data[series.data.length-1];
                  chart.xAxis[0].drawCrosshair(event, point); 
                  chart.tooltip.refresh(point); 
                }
              }
            });

            foundChannelData.hasError = convertedPointDataList[0].error;
          }
        }
      }
    },

    /**
     * グラフ再描画（遅延表示）.
     */
    async redrawPointData(){

      if ( this.mode !== 'live' && this.getChannelTimeFrom && this.getChannelTimeTo ) {
        // liveモードでなければ、 getChannelTimeFrom getChannelTimeToで設定
        this.xAxisStartValue = moment(this.getChannelTimeFrom).valueOf();
        this.xAxisEndValue = moment(this.getChannelTimeTo).valueOf();
      } else {
        // liveモードか、x軸指定の初期値が設定されていなければ、直近72時間〜現在時刻を指定

        this.xAxisStartValue = moment(this.getChannelTimeFrom).valueOf();
        this.xAxisEndValue = moment(this.getChannelTimeTo).valueOf();
      }

      const channel_data = this.channel_data.slice()

      await Promise.all(
        channel_data.map(
          async channelData => {
            if ( document.getElementById('container-' + channelData.channel_id_escaped)) {

              this.isLoadingPlotDataMap[channelData.channel_id_escaped] = channelData.channel_id;
              this.$vs.loading({
                container: '#container-parent-' + channelData.channel_id_escaped ,
                color: '#2d9cdb',
                background: 'rgba(255, 255, 255, 0.2)',
                scale: 0.6,
              });

              let chart = null;
              if (channelData.value_number_range) { // 数値データかイベントデータかの判断
                const highChartsOptions = this.getHighChartsOption(this.xAxisStartValue, this.xAxisEndValue);
                chart = await this.createChart(highChartsOptions, channelData);
              } else {
                let stringOptions = channelData.value_string_options.split("/")
                const highChartsOptions = this.getHighChartsOption(this.xAxisStartValue, this.xAxisEndValue, { stringOptions: stringOptions, channelId: channelData.channel_id });
                chart = await this.createChart(highChartsOptions, channelData, 'gantt');
              }
              this.chartsMap[channelData.channel_id] = chart;
            }
          }
        )
      )


      // チャートに座標データ群をあとから押し込む。 ( 空のチャート表示であれば、描画はそれほど遅くないのは確認済 )
      const blockSize            =    5; // APIにまとめて問合わせる時の channel_idの数.
      const initialBlock         =    1; // 初期表示(＝即時表示)させるブロック数.
      const baseDelayMilliSecond = 3000; // 最小遅延ミリ秒.
      const increaseMilliSecond  = 2000; // 遅延実行間隔. APIコールが並列で重なると、n次関数レベルで遅延が蓄積されるので、適度に間隔を空ける。
      const maxDelayMilliSecond  = 8000; // 最大遅延ミリ秒.

      _.chunk(this.channel_data, blockSize).forEach( async ( channelDataBlock, blockIndex )=> {
        const timeOutMillSecond = ( blockIndex < initialBlock ) 
                                  ? 0 
                                  : Math.min( maxDelayMilliSecond, ( baseDelayMilliSecond + increaseMilliSecond * Math.sqrt(blockIndex) ));
        setTimeout(async () => { 
          // 座標データ群の情報をAPIからまとめて取得。（２回目以降はlocalDBから取得）
          const channelDataListForChart = await this.convertChannelDataListForChart({ channelDataBlock: channelDataBlock, mode: this.mode, });
          channelDataListForChart.forEach((channelDataForChart) => {
            const chart = this.chartsMap[ channelDataForChart.channelId ];
            if ( chart && chart.series ) {
              chart.series.forEach(series => {
                  const convertedPointDataList = channelDataForChart.convertedPointDataList;

                  // HighChartsに座標データ群をセット
                  series.setData(convertedPointDataList); // 重い処理.

                  if ( channelDataForChart.convertedPointDataList.length > 0 ) {
                    // 一覧側にグラフの最終値を転送
                    const point =  convertedPointDataList[convertedPointDataList.length -1];
                    const displayMap = {
                      value:  point.y,
                      status: point.status ? point.status.replace("E", "") : point.status,
                      error:  point.error,
                    };

                    if (!channelDataForChart.channelData.value_number_range) {
                      let stringOptions = channelDataForChart.channelData.value_string_options.split("/");
                      displayMap.value = stringOptions[point.y];
                    };

                    // $setを使って、updateイベントを手動発火させる。
                    this.$set(this.displayMap, channelDataForChart.channelId, displayMap);
                    series.data[series.data.length - 1].setState("hover");
                  }

                  delete this.isLoadingPlotDataMap[ channelDataForChart.channelId ];
                  this.$vs.loading.close('#container-parent-' + channelDataForChart.channelId + ' > .con-vs-loading'); 
              });
            }
          });
        }, timeOutMillSecond );
      });      


    },

    /**
     * チャートオブジェクトを生成.
     */
    async createChart(highChartsOption, channelData, chartType) {
      let self = this;

      // Highcharts実体化.
      const chart = Highcharts.chart("container-" + channelData.channel_id_escaped, highChartsOption);

      // ツールチップ表示イベントで、となりのカラムに詳細情報を転記するメソッドを登録
      chart.options.tooltip.formatter = function() {

        const displayMap = {
          value:  this.point.y,
          status: this.point.status ? this.point.status.replace("E", "") : this.point.status,
          error:  this.point.error,
        };

        if ( chartType === 'gantt' ) {
          let stringOptions = channelData.value_string_options.split("/");
          displayMap.value = stringOptions[this.point.y];
        };

        // $setを使って、updateイベントを手動発火させる。
        self.$set(self.displayMap, channelData.channel_id, displayMap);
        
        return false;  // ツールチップを表示しない
      }

      // あとで呼び出せるようにID情報を埋め込む
      chart.options.channelId = channelData.channel_id; 
      return chart;
    },

    /**
     * x軸同期.
     * event: マウスイベント
     * type: イベントタイプ(over:軸表示処理、[else]:軸非表示処理)
     */
    async xAxisSync(event, type) {

      const xAxisValue = event.target.x;
      let map = this.chartsMap;
      let xAxisValueSync = xAxisValue;

      let promiseAll = [];
      Object.keys(map).forEach((channelId) => {
        promiseAll.push(new Promise((resolve) => {
          let chart = map[channelId];
          chart.series.forEach((series) => {

            let matchedDataIndex = 0;
            for(let dataIndex = 0; dataIndex < series.data.length; dataIndex++) {
              if( series.data[dataIndex].x <= Math.ceil(xAxisValue / 1000 ) * 1000 ) {
                matchedDataIndex = dataIndex; // マウスイベントで特定したx座標を下回る限り上書き更新 = 基準チャートと同じx座標か、その直前のx座標を特定する。

                if (type === 'over' && series.data[dataIndex].x === xAxisValue && this.xAxisValue !== xAxisValue ) {
                  // x軸情報は他のコンポーネントでも使うので、確定したら親コンポーネントに報告。
                  xAxisValueSync = xAxisValue;
                }
              } 
            }

            let point = series.data[matchedDataIndex];
            if (type === 'over') {
              chart.tooltip.hide();
              if ( chart.xAxis[0] ) { chart.xAxis[0].drawCrosshair(event, point); }
              if ( point ) { 
                point.setState('hover'); 
                chart.tooltip.refresh(point);
              }
            } else {
              if ( chart.xAxis[0] ) { chart.xAxis[0].hideCrosshair(); }
              if ( point ) {
                point.setState();
              }
            }          
          });
          resolve(channelId);
        }));
      });
      await Promise.all(promiseAll);
      this.xAxisValueSync = xAxisValueSync;
    },


    /**
     * this.displayMapの中身を安全に取得.
     */
    getSafelyDisplayMap(channelId) {
      let displayMap = this.displayMap[channelId] ? this.displayMap[channelId] : {};
      if ( displayMap.value && String(displayMap.value).match(/^[0-9]*\.[0-9]{6,}$/) ){
        displayMap.value = Number(displayMap.value).toFixed(6);  // 小数点以下が多すぎる時の暫定補正.
      }
      return displayMap;
    },

    /**
     * 共通のHighChartsオプション指定を取得.
     */
    getHighChartsOption(xAxisMinValue, xAxisMaxValue, ganttOptions) {
      let self = this;

      // 共通のHighChartsオプション指定
      let highChartsOptions = {
        chart: {
          plotBackgroundColor: "#FFFF00",
          backgroundColor: "#F8F8F8",
          borderRadius: 6,
          borderColor: "#EBBA95",
          borderWidth: 1,
          marginTop: 0,
          marginRight: 0,
          marginBottom: 0,
          marginLeft: 0,
          spacingBottom: 0,
          width: 400,
          height: 70,
        },
        title: {
          text: "",
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        xAxis: {
          type: 'datetime',
          min: xAxisMinValue,
          max: xAxisMaxValue,
          crosshair: {
              width: 3,
              color: "#2D9CDB",
          },
          labels: {
            enabled: false
          }
        },
        yAxis: {
          title: {
            text: null,
          },
          labels: {
            enabled: false,
          }, 
          offset : 40, // 目盛数値の表示幅を確保
        },
        tooltip: {
          borderWidth: 0,
          backgroundColor: 'none',
          pointFormat: '{point.x}',
          headerFormat: '',
          shadow: false,
        },
        plotOptions: {
          series: {
            color: "#2D9CDB",
            lineWidth: 1, // 散布図でも線をつなげて表示する指定
            turboThreshold: 0, // [8640+]
            point: {
              events: {
                mouseOver: (event) => {
                  self.xAxisSync(event, 'over');
                },
                mouseOut: (event) => {
                  self.xAxisSync(event, 'out');
                }
              }
            }
          }
        },
        series: [{
          type: "line",
          data: [], // 座標データは、各チャートに後からセット.
          fillOpacity: 0.3,
          fillColor: "blue",
          tooltip: {
            valueSuffix: " ", // + dataset.unit
          },
          states: {
            hover: {
              fillColor: "white",
              lineColor: "red",
              lineWidth: 5,
              brightness: 0.5,
            },
          },
        }],
      };


      // gantt custom
      if ( ganttOptions ) {
        let stringOptions = ganttOptions.stringOptions;

        highChartsOptions['xAxis']['type'] = null;

        highChartsOptions['yAxis'] = {
          title: {
            text: null
          },
          tickInterval: 1, // カテゴリ名を全部表示させるため、間隔は１。
          labels: {
            step: 1,
            formatter: function () {
              return stringOptions[this.value];
            },
          },
        };

        highChartsOptions['plotOptions']['series']['lineWidth'] = 0;
      }

      return highChartsOptions;
    },
    clearDisplayMap () {
      this.displayMap = {};
      this.chartsMap = {};
    },
    async removeCustomChannelId(data) {
      const { channel_id: channelId, channel_name: channelName } = data;
      let newChannelIds = [...this.getCustomChannelIds].filter(
        (n) => n !== channelId,
      );
      await this.setCustomChannelIdsState(newChannelIds);
      this.$vs.notify({
        title: "カスタムレポート設定",
        text: `${channelName}をカスタムレポートから削除しました。`,
        iconPack: "feather",
        icon: "icon-check",
        color: "success",
      });
      this.$emit("refreshChannelData");
    },
    handleDragEndChannelRow(evt) {
      this.drag = false;
      if (!this.selectedChannelOriginId === "custom") return;

      const {oldIndex, newIndex} = evt;
      const draggedChannelIds = this.sortedChannelIds[oldIndex];
      this.sortedChannelIds.splice(oldIndex, 1)
      this.sortedChannelIds.splice(newIndex, 0, draggedChannelIds)

      // NOTE: カスタムチャンネル保存実行箇所
      this.setCustomChannelIdsState(this.sortedChannelIds);
    },
    async addCustomChannelId(data) {
      const { channel_id: channelId, channel_name: channelName } = data;
      if (!this.getCustomChannelIds.includes(channelId)) {
        let newChannelIds = [...this.getCustomChannelIds, channelId];
        await this.setCustomChannelIdsState(newChannelIds);
        this.$vs.notify({
          title: "カスタムレポート設定",
          text: `${channelName}をカスタムレポートに追加しました。`,
          iconPack: "feather",
          icon: "icon-check",
          color: "success",
        });
      } else {
        Vue.$log.info("this id has been already added");
      }
    },
    async handleClickAddCustomReportBtn(data) {
      this.addCustomChannelId(data);
    },
    // カスタムレポート削除・追加ボタン位置調整
    handleClickMoreBtn() {
      if (!window.event) return;
      if (!window.event.x) return;
      document.documentElement.style.setProperty(
        "--more-button-dropdown-left",
        `${window.event.x + 224}px`,
      );
    },
    getYValueDisp(yValue) {
      if(typeof yValue === "number") return yValue.toLocaleString();
      return yValue;
    },
  },
  created() {
    this.webWorker = new WebWorkerForSaveChannelData();
  },
  beforeDestroy() {
    this.webWorker.terminate();
    this.setTimeoutList.forEach(timerId => clearTimeout(timerId));
  }
}
</script>

<style lang="scss">
@import url("https://code.highcharts.com/css/highcharts.css");
@import "@/assets/scss/aisea/_variables.scss";
.error-chart {
  .highcharts-area {
    fill: $aisea-red !important;
  }
  .highcharts-halo {
    fill: #eb5757;
  }
}

.engine-data-chart {
//  overflow-y: visible;
  overflow: visible;
  .engine-data-chart-parent-container {
    > div {
      @media screen and (min-width: 768px) and (min-height: 376px) {
        min-width: fit-content;
      }
    }
  }
  .row {
    overflow-wrap: break-word;
    > div {
      overflow-wrap: break-word;
      display: inline-flex;
      height: var(--row-height);
      align-items: center;
    }
    .column-handle-btn {
      cursor: grab;
      z-index: 2;
    }
    .column-channel-id {
      color: $aisea-dark-gray;
      display: none;
      @media screen and (min-width: 667px) {
        display: inline-flex;
      }
    }
    .column-channel-name {
      color: $aisea-dark-gray;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      .channel-id {
        display: block;
        @media screen and (min-width: 667px) {
          display: none;
        }
      }
    }
    .more-button {
      position: static;  // クリッカブル領域を広げる対応
    }
  }
  .no-spacer {
    padding: 0;
    margin: 0;
  }
  .highcharts-area {
    fill: $aisea-blue;
  }
  .highcharts-graph {
    stroke: $aisea-blue;
  }
  .highcharts-plot-background {
    fill: $aisea-white; // チャート背景色
  }

  .highcharts-crosshair {
    stroke: $aisea-blue;
    stroke-width: 1px;
  }

  .highcharts-background {
    fill: transparent;
  }

  .highcharts-grid-line { // チャート内側目盛線
    stroke-width: 0px;
  }

  .alerm {
    width: 24px;
    height: 24px;
    border-radius: 20px;
    margin-left: auto;
    margin-right: auto;
    background: $aisea-blue;
  }

  .column-value {
    color: $aisea-blue;
    .value {
      @media screen and (min-width: 768px) and (min-height: 376px) {
        font-size: 36px;
      }
    }
    .unit {
      padding-top: 8px;
      @media screen and (min-width: 768px) and (min-height: 376px) {
        padding-top: 13px;
        font-size: 14px;
      }
    }
  }
  .column-channel-chart {
    height: 100%;
    .chart-container {
      height: 100%;
      border: 1px solid transparent;
      border-radius: 6px;
      overflow: hidden;
    }
  }

  .value-text {
    font-size: 22px;
    line-height: 1;
  }
  .highcharts-point {
    stroke-width: 1px;
  }

  .error-status {
    background: $aisea-red;
  }
  .error-text {
    color: $aisea-red;
  }

  .zoom-in-button {
    display: block;
  }
  .chart-button {
    width: 17px;
    height: 17px;
    background: transparent;
    color: #f2f2f2;
    border-width: 1px;
    border-color: #f2f2f2;
    border-radius: 2px;
  }

  .highcharts-axis-labels {
    fill: $aisea-blue-gray;
  }

  .highcharts-tooltip-box {
    fill: $aisea-gray;
    //stroke: white;
  }

  .highcharts-tooltip text {
    fill: $aisea-white !important;
  }

  .highcharts-markers {
    fill: $aisea-white;
  }

  .data-chart-container-blank {
    width: 605px;
  }

  .highcharts-tick {
    // 目盛り線
    stroke: transparent;
  }

  .highcharts-graph { // 座標をつなぐ線
    border-radius: 8px;
  }

  .channel-row {
  //  min-width: 1600px;
    border-bottom: 1px solid #e2e2e2;
    gap: 30px;
    align-items: center;
    &:hover {
      background: #F5FAFD;
      .chart-container-wrapper {
        &:hover {
          .chart-expand-btn {
            display: block;
          }
          .chart-container {
            border-color: rgba(45, 156, 219, 1);
          }
        }
      }
    }
    @media screen and (min-width: 768px) and (min-height: 376px) {
      gap: unset;
      min-width: fit-content;
    }
  }

  .chart-control-area {
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    color: $aisea-blue;
  }

  .remove-button {
    position: absolute;
    top: 20px;
  }

  .control-button {
    cursor: pointer;
    &--disabled{
      color: $aisea-gray;
    }
  }
  .stretched-link::after{
    position:absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    left: -0.75rem; // 親要素のpadding分を調整
    z-index: 1;
    pointer-events: auto;
    content: "";
    background-color: rgba(0,0,0,0);
    @media screen and (min-width: 768px) and (min-height: 376px) {
      left: -1.5rem; // 親要素のpadding分を調整
      right: -1.5rem; // 親要素と隣の列のpadding分を調整
    }
  }
}

.save-button {
  margin: 0 0.4rem;
  width: 6rem !important;
  height: 1.6rem;
  padding: 0.1rem 0 !important;
}
.cancel-button {
  margin: 0 0.4rem;
  width: 6rem !important;
  height: 1.6rem;
  padding: 0.1rem 0 !important;
  color: $aisea-blue-gray;
}

.monitoring-engine-popup {
  .vs-popup {
    background-color: $aisea-white !important;
    width: 60vw;
  }
  header {
    h3 {
      text-align: center;
      background-color: $aisea-white;
    }
    i {
      border-radius: 2rem;
      border: 0.15rem solid $aisea-white;
      font-weight: bold;
    }
    background-color: $aisea-white;
  }
  .outer-area {
    padding: 1rem;
  }
  .save-button {
    margin: 0 1rem;
    width: 30%;
  }
  .vs-popup--close {
    background-color: $aisea-white !important;
    transform: translate(-10px, 10px);
    &:hover {
      transform: translate(-10px, 8px);
    }
  }
}
.column-channel-name-more-button-dropdown.column-channel-name-dropdown {
  --more-button-dropdown-left: unset;
  left: var(--more-button-dropdown-left) !important;
  .vs-dropdown--menu {
    width: unset;
    height: unset;
    padding: 0;
  }
  .add-custom-report-btn {
    width: 224px;
    height: 56px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    a {
      padding-left: 20px;
      padding-right: 20px;
      .add-custom-report-img {
        path {
          transition: all 0.25s ease;
          transition-timing-function: cubic-bezier(1, 0.5, 0.8, 1);
        }
      }
    }
    &:hover {
      .add-custom-report-img {
        path {
          fill: $aisea-blue;
        }
      }
    }
  }
  .vs-dropdown--menu--after {
    // 吹き出し三角を消す
    width: 0px;
    height: 0px;
  }
}
</style>
